import taskDetailJson from '../../demo/fixtures/task-detail.json'
import { Button, Icon } from '../../ui'
import styles from './TaskDetailPage.module.css'

export function LinkAlert({ onFix }: { onFix: () => void }) {
  return (
    <div className={styles.linkAlert} data-scope="detail-alert-banner">
      <span><Icon name="alert" size={20} strokeWidth={1.9} /></span>
      <b>{taskDetailJson.linkFix.bannerText}</b>
      <Button variant="ghost" className={styles.linkAlertButton} onClick={onFix}>{taskDetailJson.linkFix.bannerAction}</Button>
    </div>
  )
}
